(() => {
  class FilamentCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      if (this.slides.length < 2) return;

      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });

      this.show(this.index, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(next, restart = true) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (restart) this.start();
    }

    start() {
      this.stop();
      if (this.reducedMotion || document.hidden) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), 4400);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('filament-carousel')) {
    customElements.define('filament-carousel', FilamentCarousel);
  }
})();
